export default "__VITE_ASSET__BKEK81AX__"